import SupportElement from "../../classes/support/SupportElement";

export default class FixedSupportElement extends SupportElement {
  constructor(id, name, supportReaction) {
    super(id, name, supportReaction);
    this.classType="FixedSupportElement";
  }
}
